import { createSelector } from 'reselect';
import { NotificationType } from '../../types';
import { NotificationsState } from '../reducers';

type RootState = {
  notifications: NotificationsState;
};

export const makeGetNotifications = () =>
  createSelector(getNotifications, (notifications: NotificationType[] | null) => notifications);

export const makeGetNotificationsCount = () =>
  createSelector(getNotifications, (notifications: NotificationType[] | null) => notifications?.length);

const getNotifications = (state: RootState): NotificationType[] | null => state.notifications;
